import React from "react";
import styled from "styled-components";

import { Carousel } from "@global";
import Hero from "@shared/hero";
import { CarouselLeftArrow } from "@shared/shared.styles";
import {
  assets,
  isAnathoth,
  MOBILE_BREAKPOINT,
  SMALL_LAPTOP_BREAKPOINT,
} from "@util/constants";
import { isBrowser } from "@util/helper";

interface Props {
  hero: Queries.Maybe<Queries.SanityHero> | undefined;
  additionalHeros: readonly Queries.Maybe<Queries.SanityHero>[];
  homeHero?: boolean;
}

const HeroCarousel = (props: Props) => {
  const { hero, additionalHeros, homeHero } = props;

  if (!isBrowser()) return <Hero sanityHero={hero} />;

  const NextIcon = (
    <CarouselLeftArrow
      position="absolute"
      right="5px"
      hideOnMobile
      isAnathoth={isAnathoth}
    >
      <img src={assets.arrowRight} alt="right-arrow" />
    </CarouselLeftArrow>
  );

  const PrevIcon = (
    <CarouselLeftArrow
      rightArrow
      position="absolute"
      left="5px"
      hideOnMobile
      isAnathoth={isAnathoth}
    >
      <img src={assets.arrowRight} alt="left-arrow" />
    </CarouselLeftArrow>
  );

  return (
    <Wrapper $homeHero={homeHero}>
      <Carousel
        hideArrow={false}
        iconButton
        prevIcon={PrevIcon}
        nextIcon={NextIcon}
        hideOnMobile
        speed={30000}
        adaptiveHeight={false}
      >
        <Hero sanityHero={hero} />
        {additionalHeros.map(hero => {
          if (!hero) return null;
          return (
            <Hero key={hero?._key} sanityHero={hero} noH1 />
          );
        })}
      </Carousel>
    </Wrapper>
  );
};

export default HeroCarousel;

const Wrapper = styled.div<{ $homeHero?: boolean }>`
  .slick-track {
    display: flex !important;
  }

  .slick-slide {
    height: inherit !important;
  }

  .slick-prev {
    left: 5px;
  }

  .slick-next {
    right: 5px;
  }

  .slide {
    height: 100%;
  }
  .slick-dots li button {
    &:before {
      color: var(--theme-primary-color);
      font-size: 7px;
    }
  }

  /* Hero drops its aspect-ratio at <=1280px (see shared/hero.tsx), so hold
     a fixed height here or each slide sizes to its own text. */
  @media only screen and (min-width: ${MOBILE_BREAKPOINT + 1}px) and (max-width: ${SMALL_LAPTOP_BREAKPOINT}px) {
    .slick-slide > div,
    .slick-slide > div > div,
    #hero-wrapper {
      height: 100%;
      min-height: ${({ $homeHero }) => ($homeHero ? "520px" : "390px")};
    }
  }

  @media only screen and (max-width: ${MOBILE_BREAKPOINT}px) {
    #hero-wrapper {
      min-height: ${({ $homeHero }) => ($homeHero ? "520px" : "390px")};
      height: auto;
    }

    .slick-slide > div {
      min-height: ${({ $homeHero }) => ($homeHero ? "520px" : "390px")};
      height: auto;
    }
  }
`;
